import { InputCheck } from '../../../../../../../Forms/InputCheck'
import { api } from '../../../../../../../../services/api'
import { BsCircleFill, BsCheckSquareFill } from 'react-icons/bs'
import { useState, useEffect, useRef, useCallback } from 'react'
import { FaEllipsisV } from 'react-icons/fa'
import { toast } from 'react-toastify'
import moment from 'moment'

import { Container, ContentBusiness, StatusSync, AdditionalSettings } from './style'


export function Business({ 
    business, 
    confirmBusinessListToFilter,
    controlCheckingBusiness,
    updateBusinessListWhenSetIdCustomizer
}) {
    const [checked, setChecked] = useState(confirmBusinessListToFilter.some(code => code === business.idBusiness))
    const [isInputIdCustomizedOpen, setIsInputIdCustomizedOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [idCustomized, setIdCustomized] = useState(business.idCustomized)

    const ref = useRef(null)

    function handleClickCheckBox() {
        setChecked(!checked)
    
        controlCheckingBusiness(!checked, business.idBusiness)
    }

    async function onSubmit(event) {
        event.preventDefault()
        setIsLoading(true)

        const objectToApiPost = {
            idCustomized: idCustomized?.toUpperCase(),
            idBusiness: business.idBusiness
        }

        const objectToUpdateBusinessList = {
            ...business,
            idCustomized: idCustomized?.toUpperCase()
        }

        await api.post('/updateIdCustomized', objectToApiPost)
            .then(() => {
                updateBusinessListWhenSetIdCustomizer(objectToUpdateBusinessList)
                setIsInputIdCustomizedOpen(false)
            })
            .catch(() => toast.error('Algo deu errado, tente novamente'))
            .finally(() => setIsLoading(false))
    }

    useEffect(() => {
        setChecked(confirmBusinessListToFilter.some(code => code === business.idBusiness))
    }, [confirmBusinessListToFilter, business])

    useEffect(() => {
        if(!isInputIdCustomizedOpen)
            setIdCustomized(business.idCustomized)
    }, [isInputIdCustomizedOpen, business])


    const handleOutsideClick = useCallback(e => {
        if(!ref.current)
            return

        if(!ref.current.contains(e.target)){
            setIsInputIdCustomizedOpen(false)
        }
    }, [ref])

    useEffect(() => {
        if(isInputIdCustomizedOpen) 
            setTimeout(() => {
                document.addEventListener("click", handleOutsideClick, false)
            })
        else
            document.removeEventListener("click", handleOutsideClick, false)

        return () => document.removeEventListener("click", handleOutsideClick, false)
    }, [handleOutsideClick, isInputIdCustomizedOpen])
    

    return(
        <Container>
            <InputCheck 
                checked={checked}
                handleClick={handleClickCheckBox}
                className="inputCheck"
            />

            <ContentBusiness
                data-sync={`⌚️ Última atualização ${moment(business.lastSync?.slice(0, 16)).format('DD/MM/YYYY HH:mm')}`}
            >
                <StatusSync updated={business.updated}>
                    <BsCircleFill />
                </StatusSync>

                <p>{business.name} - {business.city}-{business.state} | {business.neighborhood}</p>
                <div className='moreBusinessInfo'>
                    {business.idCustomized && <div>{business.idCustomized}</div>}
                    {business.cnpj && <p>{'CNPJ: ' + business.cnpj}</p>}
                </div>
            </ContentBusiness>

            <AdditionalSettings 
                isLoading={isLoading}
                ref={ref}
            >
                <FaEllipsisV 
                    onClick={() => setIsInputIdCustomizedOpen(!isInputIdCustomizedOpen)}
                />

                {
                    isInputIdCustomizedOpen &&
                    <form 
                        onSubmit={onSubmit}
                        className="idCustomizedContainer"
                    >
                        <label>ID Customizado</label>

                        <div>
                            <input 
                                autoFocus
                                value={idCustomized}
                                maxLength={20}
                                onChange={event => setIdCustomized(event.target.value)}
                            />

                            <button type='submit'>
                                <BsCheckSquareFill />
                            </button>
                        </div>
                    </form>
                }
            </AdditionalSettings>
        </Container>
    )
}
